import createStaticResourceAPI from "@/helpers/rtk_static_resource_factory";

const baseURL = process.env.REACT_APP_FMS_API + '/transactions/collections';

export const collectionsAPI = createStaticResourceAPI({
  baseURL: baseURL,
  resource: "Collections",
  tagTypes: ["Collections"],
  idKey: "collectionId",
  lookupMap: ({ collectionId, referenceNo }) => ({
    value: collectionId,
    label: referenceNo
  }),
 customQuery: (query, { idKey, resource, baseURL }) => ({
    getListCollectionsForViewers: query(`${baseURL}/listForViewer`, {
      serializeQueryArgs: ({ endpointName }) => endpointName,
      providesTags: (result) => {
  if (!result?.success || !Array.isArray(result.returnData)) {
    return [{ type: resource, id: "LIST" }];
  }

  return [
    ...result.returnData.map((item) => ({
      type: resource,
      id: item[idKey],
    })),
    { type: resource, id: "LIST" },
  ];
}
    }),
  }),
  customMutations: (mutation, mutationOptions) => ({
    submitCollections: mutation(`${baseURL}/submit`, mutationOptions("save")),
    returnCollections: mutation(`${baseURL}/return`, mutationOptions("save")),
    approveCollections: mutation(`${baseURL}/approve`, mutationOptions("save")),
    rejectCollections: mutation(`${baseURL}/reject`, mutationOptions("save")),
    cancelCollections: mutation(`${baseURL}/cancel`, mutationOptions("save")),
  }),
});

export const {
  useGetCollectionsQuery,
  useGetListCollectionsForViewersQuery,
  useExportCollectionsMutation,
  useFindCollectionsQuery,
  useLookUpCollectionsMutation,
  useSaveCollectionsMutation,
  useSubmitCollectionsMutation,
  useReturnCollectionsMutation,
  useApproveCollectionsMutation,
  useRejectCollectionsMutation,
  useCancelCollectionsMutation,
  useDeleteCollectionsMutation
} = collectionsAPI;
